export default "__VITE_ASSET__ab2284e7__"